export const FUEL_CODE = 163;
export const SERVICE_CODE = 60;
export const ROAD_CARD_E100_CODE = 256;
export const ROAD_OBU_CODE = 257;
